/**
 * Body do POST `/api/Swap/IncluirAutorizacaoManual?guid={guid}`
 * (corresponde ao C# `SwapPreAutorizaRequestViewModel`).
 *
 * Apenas o identificador externo da sessão é necessário; os demais
 * dados ficam armazenados na BIS-SWAP, indexados por essa chave (a
 * etapa anterior `gravarSessao` já persistiu tudo).
 */
export interface SwapPreAutorizaRequest {
  /** Identificador externo da sessão SWAP (`DSC_SESSION_EXTERNA`). */
  sessionExterna: string;
}
